/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';
import './ServiceButtons.scss';

export default function ServiceButtons({ downloadLink, sampleLink }) {
  const { t } = useTranslation('buttons');
  return (
    <div className="service-buttons">
      <Button
        priority="primary"
        link={`/downloads/services/${downloadLink}`}
        download
      >
        {t('download_the_form')}
      </Button>
      <Button
        priority="secondary"
        link={`/downloads/services/${sampleLink}`}
        target="_blank"
      >
        {t('view_the_sample')}
      </Button>
    </div>
  );
}
